export default __webpack_public_path__ + "bd5ffc39f955d37bb53ef7d854ae4474.png";